// extracted by mini-css-extract-plugin
export default {"button":"njzSG","navigate":"yeYn+","header":"Ac9It","orderNumber":"_18skr","placedOn":"D+x3N","actions":"dXwk-"};